import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Messages.css';

import MessageManagement from '../../../components/siteadmin/MessageManagement';

const Messages = () => {

  const [state, setState] = useState({ currentPage: 1, searchList: '' });

  const setStateVariable = (variables) => {
    setState(prev => ({
      ...prev,
      ...variables
    }));
  };

  const { currentPage, searchList } = state;
  return <MessageManagement
    currentPage={currentPage}
    searchList={searchList}
    setStateVariable={setStateVariable}
  />
}

export default compose(withStyles(s))(Messages);

